import React from 'react';
import { View, Keyboard } from 'react-native';
import { StatusBar, DeviceInfo } from 'qunar-react-native';
import { Provider, observer, inject } from 'mobx-react/native';
import rootStore from '../../stores/inputTelephoneNum';
// import Icon from '../../components/Icon';
// import NumberSearchBar from './NumberSearchBar/index';
// import ModalOfInput from './ModalOfInput/index';
// import countryCodeVerify from '../../utils/countryCodeVerify';
// import generateRNUrl from '../../utils/generateRNUrl';
import InputArea from './InputArea';
import HeaderConfig from './Header';
import styles from './style';
import TimePicker from './Picker'

@observer
class InputTelephoneNum extends QView<any> {
    public static routerPlugin = HeaderConfig;
    public inputAreaRef: any;

    public bindEvents = {
        actived() {
            rootStore.qav.send({
                module: 'page',
                operType: 'show'
            });
        },
        deactived() {
            Keyboard.dismiss();
        }
    };

    public componentDidMount() {
        if (DeviceInfo.isIOS || (!DeviceInfo.isIOS && Number(DeviceInfo.vid) > 60001224)) {
            StatusBar.setStyle(
                'dark',
                () => {},
                () => {}
            );
        }
        try {
            rootStore.inputArea.resetTimePicker();
            this.inputAreaRef.wrappedInstance.resetPageData();

        } catch (e) {
            console.log(e);
        }
    }

    public render() {
        return (
            <Provider {...rootStore}>
                <View style={styles.pageRoot}>
                    <InputArea
                        ref={(ele) => {
                            this.inputAreaRef = ele;
                        }}
                    />
                    {/* 选择年份弹窗 */}
                    <View style={{flex: 1}}/>
                    <TimePicker/>
                </View>
            </Provider>
        );
    }
}

export default InputTelephoneNum;
